const FOR_TEMPLATE_AUTHORS = 1;
const FOR_DOCUMENT_AUTHORS = 2;

export {
    FOR_DOCUMENT_AUTHORS,
    FOR_TEMPLATE_AUTHORS
}